export const threadsKeys = {
    all: () => ['threads'],
    history: () => [...threadsKeys.all(), 'history'],
    historyPages: () => [...threadsKeys.all(), 'history-pages']
};
//# sourceMappingURL=threads.keys.js.map